import React, { useState, useEffect } from 'react';
import { useLang } from '../contexts/LanguageContext';

const CONTENT = {
  en: {
    text: 'This site uses cookies solely to measure audience and traffic. No personal data is collected or shared.',
    accept: 'Accept',
    decline: 'Decline',
  },
  pt: {
    text: 'Este site usa cookies apenas para medir a afluência e o público visitante. Não são recolhidos nem partilhados dados pessoais.',
    accept: 'Aceitar',
    decline: 'Recusar',
  },
};

const STORAGE_KEY = 'tw-cookie-consent';

const CookieBanner = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);
  const c = CONTENT[lang] || CONTENT.en;

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
      if (stored === 'accepted') grantAnalytics();
    } catch {}
  }, []);

  const grantAnalytics = () => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
  };

  const handleAccept = () => {
    try { localStorage.setItem(STORAGE_KEY, 'accepted'); } catch {}
    grantAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    try { localStorage.setItem(STORAGE_KEY, 'declined'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#1a1a2e',
      color: '#e0e0e0',
      padding: '0.85rem 1.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1.2rem',
      flexWrap: 'wrap',
      fontSize: '0.85rem',
      zIndex: 9999,
      boxShadow: '0 -2px 12px rgba(0,0,0,0.3)',
    }}>
      <span style={{ flex: '1 1 260px', maxWidth: '600px', lineHeight: 1.5 }}>{c.text}</span>
      <div style={{ display: 'flex', gap: '0.6rem', flexShrink: 0 }}>
        <button onClick={handleDecline} style={{
          padding: '0.4rem 1rem',
          background: 'transparent',
          border: '1px solid #666',
          borderRadius: '6px',
          color: '#aaa',
          cursor: 'pointer',
          fontSize: '0.82rem',
        }}>{c.decline}</button>
        <button onClick={handleAccept} style={{
          padding: '0.4rem 1rem',
          background: '#007bff',
          border: 'none',
          borderRadius: '6px',
          color: 'white',
          cursor: 'pointer',
          fontSize: '0.82rem',
          fontWeight: 600,
        }}>{c.accept}</button>
      </div>
    </div>
  );
};

export default CookieBanner;
